import { render, staticRenderFns } from "./ReportingWidget.vue?vue&type=template&id=13004044&scoped=true&"
import script from "./ReportingWidget.vue?vue&type=script&lang=js&"
export * from "./ReportingWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportingWidget.vue?vue&type=style&index=0&id=13004044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13004044",
  null
  
)

export default component.exports